import React from 'react'
import MainLayout from '../layouts/MainLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import MrConnectIotCloudPlatform from './../pages/Products/MrConnectIotCloudPlatform/MrConnectIotCloudPlatform';
import NotFound from '../pages/NotFound/NotFound';


const PageRouters = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/mrconnect-iot-cloud-platform" />} />
      <Route element={<MainLayout />}>
        <Route path="*" element={<NotFound />} />
        <Route path="/mrconnect-iot-cloud-platform" element={<MrConnectIotCloudPlatform />} />
      </Route>
    </Routes>
  )
}

export default PageRouters